import * as React from 'react';
import { Modal, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import * as actionCreator from '../../actions/actions';
import { Dispatch } from 'redux';
import Select from 'react-select';
import { MyLookup } from '../../class/Enums';
import { LookupItem } from '../../class/LookupItem';
import '../css/ModernPopups.css';

interface State {
    entryId: any;
    entryName: any;
    entryCheckIn: any;
    entryCheckOut: any;
    flat: any;
    key: any;
    entryCode: any;
    //isDoorCodeValid: any;
}

interface Props {
    popupTitle: string,
    selectedEntry: any,
    token: any,
    show: boolean,
    isDoorCodeValide: boolean,
    isDoorCodeValideRedux: boolean,
    flatLookupList: any;
    keyLookupList  :any;
    hide(error: string): void,
    saveEntry(token: any, entry: any): void;
    updateEntry(token: any, entry: any): void;
    checkCode(token: any, code: any): void;
    getLookupList(): any;
}

//map the props of this class to the root redux state
const mapStateToProps = (state: any) => {
    return {
        entryId: state.entryId,
        isDoorCodeValideRedux: Boolean(state.isDoorCodeValide),
        flatLookupList: state.lookupList[MyLookup.FLatList],
        keyLookupList: state.lookupList[MyLookup.KeyList],
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        saveEntry: (token: any, entry: any) => dispatch<any>(actionCreator.default.smartHouse.saveEntry(token, entry)),
        updateEntry: (token: any, entry: any) => dispatch<any>(actionCreator.default.smartHouse.updateEntry(token, entry)),
        checkCode: (token: any, entry: any) => dispatch<any>(actionCreator.default.smartHouse.checkCode(token, entry)),
        getLookupList: () => dispatch<any>(actionCreator.default.lookup.getLookupList()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(class SmartHouseEntryPopup extends React.Component<Props, State> {
    private socket: any;

    constructor(props: any) {
        super(props)
        this.state = {
            entryId: 0,
            entryName: '',
            entryCheckIn: '',
            entryCode: '',
            entryCheckOut: '',
            flat : '',
            key : ''
        };
    }

    componentDidMount() {
        this.props.getLookupList();
    }

    componentDidUpdate(prevProps: any) {
       
        if (this.props !== prevProps && this.props.selectedEntry) {
            console.log(this.props.selectedEntry);
            this.setState({
                entryId: this.props.selectedEntry.entryId,
                entryName: this.props.selectedEntry.entryName,
                entryCheckIn: this.props.selectedEntry.entryCheckIn,
                entryCheckOut: this.props.selectedEntry.entryCheckOut,
                entryCode: this.props.selectedEntry.entryCode,
                key: { label: this.props.selectedEntry.key ? this.props.selectedEntry.key.keyId + " | " + this.props.selectedEntry.key.keyDescription : null, value: this.props.selectedEntry.key ? this.props.selectedEntry.key.keyId : null },
                flat: { label: this.props.selectedEntry.flat ? this.props.selectedEntry.flat.flatName : null, value: this.props.selectedEntry.flat ? this.props.selectedEntry.flat.flatId : null },
            })
        }
    }

    handleChange = (e: any) => {
        this.setState({
            [e.target.id]: e.target.value
        } as any);

        if (e.target.id == 'entryCode' && e.target.value.length == 4) {
            let newEntry: any;
            newEntry = { entryCode: e.target.value };
            this.props.checkCode(this.props.token, newEntry);
        }
    }

    handleFlatChange = (e: any) => {
        this.setState({
            flat: e
        });
    }

    handleKeyChange = (e: any) => {
        this.setState({
            key: e
        });
    }

    handleSaveEntry = (e: any) => {
        e.preventDefault();
        var myEntry: any = ({
            entryId: this.state.entryId,
            entryCode: this.state.entryCode,
            entryName: this.state.entryName,
            flatId : this.state.flat.value,
            keyId : this.state.key.value,
            entryCheckIn: this.state.entryCheckIn,
            entryCheckOut: this.state.entryCheckOut
        });
        if (myEntry.entryId != undefined) {
            this.props.updateEntry(this.props.token, myEntry);
         }
         else {
            this.props.saveEntry(this.props.token, myEntry);
         }
        
        this.props.hide("");
    }

    generateRandomCode = () => {
        let entryCode = Math.floor(1000 + Math.random() * 9000)
        this.setState({
            entryCode: entryCode,
        })
        let newEntry: any;
        newEntry = { entryCode: entryCode };
        this.props.checkCode(this.props.token, newEntry);
    }

    render() {
        return (
            <Modal 
                show={this.props.show} 
                onHide={() => this.props.hide("")}
                className="modern-modal"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-user-plus"></i>
                        {this.props.popupTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form id="newEntryForm" onSubmit={this.handleSaveEntry}>
                        <input 
                            id="EntryId" 
                            value={this.state.entryId} 
                            type="hidden" 
                            readOnly 
                        />

                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-user"></i>
                                Guest Name
                            </label>
                            <input 
                                id="entryName" 
                                value={this.state.entryName} 
                                type="text" 
                                className="modern-form-control" 
                                placeholder="Enter guest name" 
                                required 
                                onChange={this.handleChange}
                            />
                        </div>

                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-lock"></i>
                                Door Code
                            </label>
                            {(!this.props.isDoorCodeValide || !this.props.isDoorCodeValideRedux) && (
                                <div className="modern-alert modern-alert-error">
                                    <i className="fas fa-exclamation-triangle me-2"></i>
                                    This code is already in use! Please choose a different code.
                                </div>
                            )}
                            <div className="input-group">
                                <input 
                                    id="entryCode" 
                                    value={this.state.entryCode} 
                                    type="text" 
                                    className="modern-form-control" 
                                    placeholder="Enter 4-digit code" 
                                    maxLength={4}
                                    pattern="[0-9]{4}"
                                    required 
                                    onChange={this.handleChange}
                                />
                                <Button 
                                    variant="outline-secondary" 
                                    type="button" 
                                    onClick={() => this.generateRandomCode()}
                                    style={{ borderRadius: '0 8px 8px 0', borderLeft: 'none' }}
                                >
                                    <i className="fas fa-random me-1"></i>
                                    Generate
                                </Button>
                            </div>
                        </div>

                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-home"></i>
                                Flat Assignment
                            </label>
                            <div className="modern-select">
                                <Select 
                                    id="flatId" 
                                    placeholder="Select a flat" 
                                    onChange={this.handleFlatChange} 
                                    options={this.props.flatLookupList} 
                                    value={this.state.flat}
                                />
                            </div>
                        </div>

                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-key"></i>
                                Access Key
                            </label>
                            <div className="modern-select">
                                <Select 
                                    id="keyId" 
                                    placeholder="Select an access key" 
                                    onChange={this.handleKeyChange} 
                                    value={this.state.key} 
                                    options={this.props.keyLookupList}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-sign-in-alt"></i>
                                        Check-in Date
                                    </label>
                                    <input 
                                        id="entryCheckIn" 
                                        value={this.state.entryCheckIn} 
                                        type="datetime-local" 
                                        className="modern-form-control" 
                                        required 
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="modern-form-group">
                                    <label className="modern-form-label">
                                        <i className="fas fa-sign-out-alt"></i>
                                        Check-out Date
                                    </label>
                                    <input 
                                        id="entryCheckOut" 
                                        value={this.state.entryCheckOut} 
                                        type="datetime-local" 
                                        className="modern-form-control" 
                                        required 
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.hide("")}>
                        <i className="fas fa-times me-2"></i>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" form="newEntryForm">
                        <i className="fas fa-save me-2"></i>
                        Save Entry
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
})